(() => {
  const dataNode = document.querySelector('[data-phase4-page-data]');
  let page = {};
  try { page = JSON.parse(dataNode?.textContent || '{}'); } catch (_) {}
  const push = (event, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, phase4: true, ...detail });
  };

  function pageView() {
    if (page.product) push('view_item', { ecommerce: { currency: page.product.currency, value: page.product.price, items: [{ item_id: String(page.product.id), item_name: page.product.title, item_brand: page.product.vendor, item_variant: String(page.product.variant_id), price: page.product.price }] } });
    else if (page.collection) push('view_item_list', { item_list_id: page.collection.handle, item_list_name: page.collection.title, item_count: page.collection.count });
    else if (page.cart) push('view_cart', { ecommerce: { currency: page.cart.currency, value: page.cart.total, item_count: page.cart.item_count } });
  }

  function setupInteractionTracking() {
    document.addEventListener('click', (event) => {
      const productLink = event.target.closest('main[data-template^="collection"] a[href*="/products/"],.phase2-product-card a[href*="/products/"],.phase0-recommendation-card a[href*="/products/"]');
      if (productLink) push('select_item', { item_url: productLink.href, list: page.collection?.handle || 'recommendation' });

      const add = event.target.closest('form[action*="/cart/add"] button[type="submit"],form[action*="/cart/add"] input[type="submit"],[data-phase0-sticky-button]');
      if (add) push('add_to_cart_intent', { product_id: page.product?.id, variant_id: page.product?.variant_id });

      const checkout = event.target.closest('a[href*="/checkout"],button[name="checkout"],input[name="checkout"]');
      if (checkout) push('begin_checkout_intent', { cart_value: page.cart?.total, item_count: page.cart?.item_count });

      const whatsapp = event.target.closest('a[href*="wa.me"],a[href*="api.whatsapp.com"]');
      if (whatsapp) push('whatsapp_intent', { href: whatsapp.href, page_type: page.page_type });
    }, { passive: true });
  }

  function observeVitals() {
    if (!('PerformanceObserver' in window)) return;
    try {
      new PerformanceObserver((list) => {
        const entries = list.getEntries();
        const last = entries[entries.length - 1];
        if (last) push('web_vital_lcp', { value: Math.round(last.startTime), element: last.element?.tagName || '' });
      }).observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (_) {}
    try {
      let cls = 0;
      new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => { if (!entry.hadRecentInput) cls += entry.value; });
      }).observe({ type: 'layout-shift', buffered: true });
      addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') push('web_vital_cls', { value: Number(cls.toFixed(4)) }); }, { once: true });
    } catch (_) {}
    try {
      new PerformanceObserver((list) => {
        const worst = list.getEntries().reduce((max, entry) => Math.max(max, entry.duration), 0);
        if (worst) push('web_vital_inp', { value: Math.round(worst) });
      }).observe({ type: 'event', buffered: true, durationThreshold: 40 });
    } catch (_) {}
  }

  function addScanNotes() {
    const confidence = document.querySelector('[data-phase2-pdp-confidence]');
    if (!confidence || document.querySelector('[data-phase4-scan-note]')) return;
    const note = document.createElement('div');
    note.className = 'phase4-scan-note';
    note.dataset.phase4ScanNote = 'true';
    note.innerHTML = '<span>Free India shipping</span><span>1–2 day processing</span><span>3-days issue support</span>';
    confidence.insertAdjacentElement('afterend', note);
  }

  pageView();
  setupInteractionTracking();
  addScanNotes();
  if ('requestIdleCallback' in window) requestIdleCallback(observeVitals, { timeout: 2500 });
  else setTimeout(observeVitals, 1800);
  document.addEventListener('shopify:section:load', addScanNotes);
})();
